/*
 * @Author: Gang Jiang 
 * @Date: 2024-09-12 15:06:55 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-09-27 14:19:44
 */

<template>
  <div class="in-rewards">
    <header>
      <div class="header">
        <h1 />
        <a-dropdown v-if="userName.length">
          <span
            class="ant-dropdown-link"
            @click="(e) => e.preventDefault()"
          >
            Hi, {{ userName }} <DownOutlined />
          </span>
          <template #overlay>
            <a-menu>
              <a-menu-item>
                <span @click="logout">Sign out</span>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
    </header>
    <div class="content-wrapper">
      <aside class="left">
        <side-bar />
      </aside>
      <section class="right">
        <router-view />
      </section>
    </div>
  </div>
</template>

<script>
import { DownOutlined } from '@ant-design/icons-vue'
import SideBar from '../components/sideBar.vue'
export default {
  name: 'InRewards',
  components: { SideBar, DownOutlined },
  data() {
    return {
      userName: '',
    }
  },
  mounted() {
    const now = new Date().getTime()
    const targetTime = localStorage.getItem('tokenTime')
    const tenHoursInMillis = 10 * 60 * 60 * 1000
    if (
      localStorage.getItem('adminToken') &&
      now - targetTime > tenHoursInMillis
    ) {
      location.href = '/#/login'
    }
    this.userName = localStorage.getItem('adminToken')
      ? localStorage.getItem('adminToken').split('|')[0]
      : ''
  },
  methods: {
    logout() {
      localStorage.removeItem('adminToken')
      location.href = '/#/login'
    },
  },
}
</script>

<style lang="less">
body {
  background: #f2f2f2;
}
.bread-crumb {
  color: #999;
  font-size: 12px;
  .current {
    color: #000;
    margin-left: 25px;
    position: relative;
    &:before {
      top: -1px;
      left: -14px;
      content: '/';
      font-size: 14px;
      color: #999;
      position: absolute;
    }
  }
}
.ant-modal {
  div[aria-hidden='true'] {
    display: none !important;
  }
  &-header {
    margin: 0 -24px 20px !important;
    padding-bottom: 15px !important;
    border-bottom: 1px solid #e8e8e8;
  }
  &-title {
    margin-left: 24px !important;
  }
}
// .ant-input,
// .ant-select-selector,
// .ant-btn-default {
//   border-color: #e8e8e8 !important;
// }
.status {
  display: block;
  margin-left: 20px;
  position: relative;
  white-space: nowrap;
  &:before {
    top: 50%;
    width: 6px;
    left: -13px;
    height: 6px;
    content: '';
    position: absolute;
    border-radius: 50%;
    transform: translateY(-50%);
    background-color: #52c41a;
  }
  &.inactive:before {
    background-color: #f00;
  }
}
</style>
<style lang="less" scoped>
.in-rewards {
  min-width: 100vh;
}
header {
  border-bottom: 1px solid #ebebeb;
  .header {
    height: 60px;
    display: flex;
    margin: 0 20px;
    min-width: 1200px;
    line-height: 60px;
    align-items: center;
    justify-content: space-between;
  }

  h1 {
    width: 133px;
    height: 38px;
    margin-top: 0;
    margin-bottom: 0;
    background: url(../assets/logo2.svg) no-repeat center center;
    background-size: contain;
  }
}
.ant-dropdown-link {
  height: 20px;
  cursor: pointer;
  line-height: 20px;
  :deep(.anticon-down) {
    font-size: 12px;
  }
}
.content-wrapper {
  display: flex;
  overflow: hidden;
  min-width: 1200px;
  height: calc(100vh - 61px);
  .left {
    flex-shrink: 0;
    padding-top: 20px;
    margin-left: 20px;
    border-right: 1px solid #e8e8e8;
    > span {
      height: 40px;
      margin: 0 20px;
      display: block;
      cursor: pointer;
      font-size: 16px;
      line-height: 40px;
      text-align: center;
      border-radius: 6px;
      &.active {
        background-color: #fff;
      }
    }
  }
  .right {
    flex: 1;
    overflow-y: auto;
    width: calc(100% - 200px);
    padding: 20px 20px 0 20px;
  }
}
</style>